import { ONE_INCH_TO_MM } from "pxc-editor-core/constants";

export const dpiToDpmm = dpi => dpi / ONE_INCH_TO_MM;

export const dpmmToDpi = dpmm => dpmm * ONE_INCH_TO_MM;

export const nodeToString = (node) => {
  const serializer = new XMLSerializer();

  const serializedString = serializer.serializeToString(node);

  //*** after we start include fonts as base64 string to svg, regexp operation takes much time.
  //*** so we don't use this example, but include correct attributes in code
  // res = res.replace(/(\w+)?:?xlink=/g, 'xmlns:xlink='); // Fix root xlink without namespace

  //*** next example has small speed-down for one item
  const updatedSerializedString = serializedString.replace(/NS\d+:href/g, 'xlink:href'); // Safari NS namespace fix

  const cleanedSvgString = updatedSerializedString.replace(/<foreignObject[\s\S]*?<\/foreignObject>/g, '');

  return cleanedSvgString;
};
